import React from 'react';

function Contraintes() {
  return <div>Contraintes</div>;
}

export default Contraintes;
